import React from "react";

export interface DecisionFile {
	name: string;
	/** Download URL. Optional in preview (files may not be persisted yet). */
	url?: string;
}

export interface DecisionFilesDisplayProps {
	decisionFiles?: DecisionFile[];
}

/**
 * Mirrors the backend `mail.rfx.components.decision-files` partial: a bulleted
 * list of decision attachments shown as external "download via this link"
 * anchors. Renders nothing when there are no files. Used in the award /
 * not-awarded email previews so the preview matches the real email.
 */
export const DecisionFilesDisplay = ({
	decisionFiles,
}: DecisionFilesDisplayProps) => {
	if (!decisionFiles || decisionFiles.length === 0) {
		return null;
	}

	const intro =
		decisionFiles.length === 1
			? "The following document has been provided for you:"
			: "The following documents have been provided for you:";

	return (
		<tr>
			<td
				style={{
					fontFamily: "Arial, sans-serif",
					fontSize: "16px",
					lineHeight: "24px",
					color: "#374151",
					paddingBottom: "20px",
				}}
			>
				{intro}
				<ul style={{ margin: "8px 0 0 0", paddingLeft: "20px" }}>
					{decisionFiles.map((file) => (
						<li key={file.name} style={{ paddingBottom: "6px" }}>
							{file.name} —{" "}
							<a href={file.url ?? "#"} style={{ color: "#0f766e" }}>
								download via this link
							</a>
						</li>
					))}
				</ul>
			</td>
		</tr>
	);
};
